<template>
  <div>
    <div class="justify-content-between align-items-center d-flex">
      <h3>
        <feather-icon size="22" icon="InfoIcon" />
        معلومات الإشهار
      </h3>
      <b-button
        v-can="{ slug: 'ngo-profile', action: 'O' }"
        @click="openPublicationInfoModal"
        variant="primary"
      >
        <feather-icon size="16" icon="EditIcon" class="mr-50" />
        تعديل
      </b-button>
    </div>
    <hr />
    <b-row>
      <b-col md="6" cols="12">
        <info-card
          label="نطاق عمل المنظمة حسب قرار اشهارها"
          :value="ngoData.governorates.map((el) => el.name_ar).join(' , ')"
        />
      </b-col>
      <b-col md="6" cols="12">
        <info-card label="حالة المنظمة" :value="ngoData.status.name_ar" />
      </b-col>
      <b-col md="6" cols="12">
        <info-card label="رقم قرار الإشهار" :value="ngoData.decision_no" />
      </b-col>
      <b-col md="6" cols="12">
        <info-card label="تاريخ قرار الإشهار" :value="ngoData.decision_date" />
      </b-col>
      <b-col md="6" cols="12">
        <info-card
          label="هل تمتلك صفة النفع العام؟"
          :value="parseBoolean(ngoData.has_public_benefit)"
        />
      </b-col>
      <b-col md="6" cols="12">
        <info-card
          label="لدى المنظمة نظام داخلي خاص بالموظفين"
          :value="parseBoolean(ngoData.has_emp_internal_system)"
        />
      </b-col>
      <b-col md="6" cols="12">
        <info-card
          label="لدى المنظمة نظام خاص بالنساء"
          :value="parseBoolean(ngoData.has_women_private_system)"
        />
      </b-col>
      <b-col md="6" cols="12">
        <info-card
          label="لدى المنظمة نظام خاص بالتطوع"
          :value="parseBoolean(ngoData.has_volunteering_system)"
        />
      </b-col>
      <b-col md="6" cols="12">
        <info-card
          label="لدى المنظمة هيكل تنظيمي معتمد ومعمول به"
          :value="parseBoolean(ngoData.has_organizational_structure)"
        />
      </b-col>
    </b-row>
    <form-modal
      v-model="publicationInfoModal"
      title="معلومات الإشهار"
      :formSchema="publicationInfoSchema"
      ref="publicationInfoModal"
      :loading="loading"
      @confirm="onPublicationFormConfirmed"
    />
  </div>
</template>

<script>
import FormModal from "@/components/FormModal.vue";
import InfoCard from "@/components/InfoCard.vue";
import { BRow, BCol, BButton } from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";
const boolYesNoOptions = [
  {
    title: "نعم",
    value: true,
  },
  {
    title: "لا",
    value: false,
  },
];
export default {
  components: {
    BRow,
    BCol,
    BButton,
    InfoCard,
    FormModal,
  },

  data() {
    return {
      publicationInfoModal: false,
      publicationInfoSchema: {
        has_public_benefit: {
          component: "FormSelect",
          key: "has_public_benefit",
          attrs: {
            id: "has-public-benfit",
            label: "تمتلك صفة النفع العام",
            options: boolYesNoOptions,
            reduce: (x) => x.value,
            getOptionLabel: (x) => x.title,
            rules: "required",
          },
        },
        has_emp_internal_system: {
          component: "FormSelect",
          key: "has_emp_internal_system",
          attrs: {
            id: "has-emp",
            label: "لدى المنظمة نظام داخلي خاص بالموظفين",
            options: boolYesNoOptions,
            reduce: (x) => x.value,
            getOptionLabel: (x) => x.title,
            rules: "required",
          },
        },
        has_women_private_system: {
          component: "FormSelect",
          key: "has_women_private_system",
          attrs: {
            id: "has-women",
            label: "لدى المنظمة نظام خاص بالنساء",
            options: boolYesNoOptions,
            reduce: (x) => x.value,
            getOptionLabel: (x) => x.title,
            rules: "required",
          },
        },
        has_volunteering_system: {
          component: "FormSelect",
          key: "has_volunteering_system",
          attrs: {
            id: "has-volunteering",
            label: "لدى المنظمة نظام خاص بالتطوع",
            options: boolYesNoOptions,
            reduce: (x) => x.value,
            getOptionLabel: (x) => x.title,
            rules: "required",
          },
        },
        has_organizational_structure: {
          component: "FormSelect",
          key: "has_organizational_structure",
          attrs: {
            id: "has-organizational",
            label: "لدى المنظمة هيكل تنظيمي معتمد ومعمول به",
            options: boolYesNoOptions,
            reduce: (x) => x.value,
            getOptionLabel: (x) => x.title,
            rules: "required",
          },
        },
      },
    };
  },
  methods: {
    ...mapActions("NgoProfile/NgoInfo", ["editNgoData"]),

    onPublicationFormConfirmed(form) {
      this.editNgoData(form);
    },
    openPublicationInfoModal() {
      var initialForm = {
        has_public_benefit: this.ngoData.has_public_benefit,
        has_emp_internal_system: this.ngoData.has_emp_internal_system,
        has_women_private_system: this.ngoData.has_women_private_system,
        has_volunteering_system: this.ngoData.has_volunteering_system,
        has_organizational_structure: this.ngoData.has_organizational_structure,
      };
      if (this.canUpdateCriticalInfo) {
        this.publicationInfoSchema = {
          ...{
            governorates_ids: {
              component: "FormSelect",
              key: "governorates_ids",
              attrs: {
                id: "governorates",
                label: "نطاق عمل المنظمة حسب قرار اشهارها",
                ep: "v2/selects/governorates",
                reduce: (x) => x.id,
                getOptionLabel: (x) => x.name_ar,
                rules: "required",
                closeOnSelect: false,
                multiple: true,
              },
            },
            status_id: {
              component: "FormSelect",
              key: "status_id",
              attrs: {
                id: "status",
                label: "حالة المنظمة",
                ep: "v2/selects/status",
                reduce: (x) => x.id,
                getOptionLabel: (x) => x.name_ar,
                rules: "required",
              },
            },
            decision_no: {
              component: "FormInput",
              key: "decision_no",
              attrs: {
                label: "رقم قرار الإشهار",
                rules: "required",
              },
            },
            decision_date: {
              component: "FormMask",
              key: "decision_date",
              attrs: {
                placeholder: "YYYY-MM-DD",
                options: "date",
                label: "تاريخ قرار الإشهار",
                rules: "required",
              },
            },
          },
          ...this.publicationInfoSchema,
        };
        Object.assign(initialForm, {
          governorates_ids: this.ngoData.governorates.map((el) => el.id),
          status_id: this.ngoData.status.id,
          decision_no: this.ngoData.decision_no,
          decision_date: this.ngoData.decision_date,
        });
      }

      this.$refs.publicationInfoModal.init(initialForm);
      this.publicationInfoModal = true;
    },
    parseBoolean(val) {
      return val === false ? "لا" : "نعم";
    },
  },
  computed: {
    ...mapGetters("NgoProfile/NgoInfo", ["loading"]),
    ...mapGetters("NgoProfile", ["ngoData", "canUpdateCriticalInfo"]),
  },
};
</script>
